export type WorldlineRedirectState = {
  paymentGatewayPaymentId: string;
  amountCents: number;
};

const getWorldlineRedirectStateKey = (sessionUuid: string) => `worldline_payment_${sessionUuid}`;

export const setWorldlineRedirectState = (sessionUuid: string, state: WorldlineRedirectState) => {
  sessionStorage.setItem(getWorldlineRedirectStateKey(sessionUuid), JSON.stringify(state));
};

export const getWorldlineRedirectState = (sessionUuid: string): WorldlineRedirectState | null => {
  const storedState = sessionStorage.getItem(getWorldlineRedirectStateKey(sessionUuid));

  if (!storedState) return null;

  try {
    const parsedState = JSON.parse(storedState) as Partial<WorldlineRedirectState>;

    if (
      typeof parsedState.paymentGatewayPaymentId !== 'string' ||
      typeof parsedState.amountCents !== 'number'
    ) {
      clearWorldlineRedirectState(sessionUuid);
      return null;
    }

    return {
      paymentGatewayPaymentId: parsedState.paymentGatewayPaymentId,
      amountCents: parsedState.amountCents,
    };
  } catch {
    clearWorldlineRedirectState(sessionUuid);
    return null;
  }
};

export const clearWorldlineRedirectState = (sessionUuid: string) => {
  sessionStorage.removeItem(getWorldlineRedirectStateKey(sessionUuid));
};
